// frontend/src/pages/admin/ManageDashboardSettingsPage.js
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { 
    FaCog, FaSave, FaSyncAlt, FaLayerGroup, FaUserCog, FaChartBar, FaEye 
} from 'react-icons/fa';

// Switch Bileşeni
const Switch = ({ checked, onChange, label }) => (
    <label className="flex items-center justify-between p-3 bg-gray-800 rounded-lg cursor-pointer hover:bg-gray-750 transition-colors border border-gray-700">
        <span className="text-sm font-medium text-gray-300">{label}</span>
        <div className="relative">
            <input type="checkbox" className="sr-only" checked={checked} onChange={onChange} />
            <div className={`block w-10 h-6 rounded-full transition-colors ${checked ? 'bg-primary' : 'bg-gray-600'}`}></div>
            <div className={`dot absolute left-1 top-1 bg-white w-4 h-4 rounded-full transition-transform ${checked ? 'transform translate-x-4' : ''}`}></div>
        </div>
    </label>
);

const ManageDashboardSettingsPage = () => {
    const [settings, setSettings] = useState(null);
    const [loading, setLoading] = useState(true);
    const [msg, setMsg] = useState(null);

    const API_URL = process.env.NODE_ENV === 'production' ? '/api' : 'http://localhost:5000/api';
    const getCleanToken = () => localStorage.getItem('token')?.replace(/"/g, '');

    const fetchSettings = async () => {
        setLoading(true);
        try {
            const token = getCleanToken();
            const { data } = await axios.get(`${API_URL}/settings`, { headers: { Authorization: `Bearer ${token}` } });
            setSettings(data);
            setLoading(false);
        } catch (error) { console.error(error); setLoading(false); }
    };

    useEffect(() => { fetchSettings(); }, []);

    // --- KRİTİK DÜZELTME BURADA ---
    const handleSave = async () => {
        try {
            const token = getCleanToken();
            
            // DİKKAT: axios.put YERİNE axios.post KULLANIYORUZ!
            // URL sonuna ?_method=PUT ekliyoruz.
            // Bu sayede IIS sunucusu bunu POST sanıp izin veriyor, Backend ise PUT olarak işliyor.
            
            await axios.post(
                `${API_URL}/settings?_method=PUT`, 
                settings, 
                { headers: { Authorization: `Bearer ${token}` } }
            );

            setMsg({ type: 'success', text: 'Ayarlar başarıyla kaydedildi ve sisteme yansıdı.' });
            setTimeout(() => setMsg(null), 3000);
        } catch (error) {
            console.error("Save Error:", error);
            const errText = error.response?.data?.message || 'Kaydedilemedi (Sunucu Hatası)';
            setMsg({ type: 'error', text: errText });
        }
    };
    // -----------------------------

    // Nested Obje Güncelleme Yardımcısı
    const update = (section, key, value) => {
        setSettings(prev => ({
            ...prev,
            [section]: { ...prev[section], [key]: value }
        }));
    };

    if (loading) return <div className="p-10 text-white animate-pulse">Yükleniyor...</div>;

    return (
        <div className="space-y-6 pb-10">
            <div className="flex justify-between items-center">
                <div>
                    <h1 className="text-2xl font-bold text-white flex items-center gap-2">
                        <FaCog className="text-gray-400"/> Dashboard Ayarları
                    </h1>
                    <p className="text-text-secondary text-sm">Kullanıcıların ne göreceğini buradan yönetin.</p>
                </div>
                <button onClick={handleSave} className="bg-green-600 hover:bg-green-500 text-white px-6 py-2 rounded-lg font-bold flex items-center gap-2 shadow-lg hover:shadow-green-500/20 transition-all">
                    <FaSave /> KAYDET
                </button>
            </div>

            {msg && <div className={`p-4 rounded-lg border ${msg.type === 'success' ? 'bg-green-500/10 border-green-500/30 text-green-400' : 'bg-red-500/10 border-red-500/30 text-red-400'}`}>{msg.text}</div>}

            {settings && (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">

                {/* 1. SON İŞLEMLER KARTI */}
                <div className="bg-surface border border-border p-6 rounded-xl shadow-lg">
                    <h3 className="text-lg font-bold text-white mb-4 flex items-center gap-2"><FaLayerGroup className="text-blue-400"/> Son İşlemler Kartı</h3>
                    <div className="space-y-3">
                        <Switch 
                            label="Kartı Göster" 
                            checked={settings.recentActivities.show} 
                            onChange={e => update('recentActivities', 'show', e.target.checked)} 
                        />
                        <div className={`space-y-3 pl-4 border-l-2 border-gray-700 transition-opacity ${!settings.recentActivities.show && 'opacity-50 pointer-events-none'}`}>
                            <Switch label="İsim Soyisim Tam Göster" checked={settings.recentActivities.showFullNames} onChange={e => update('recentActivities', 'showFullNames', e.target.checked)} />
                            <Switch label="Ödeme Durumu (Ödendi/Bekliyor)" checked={settings.recentActivities.showStatus} onChange={e => update('recentActivities', 'showStatus', e.target.checked)} />
                            <div>
                                <label className="text-xs text-gray-400 block mb-1">Gösterilecek İşlem Sayısı</label>
                                <input type="number" min="1" max="20" className="w-full bg-black/20 border border-gray-600 rounded p-2 text-white" 
                                    value={settings.recentActivities.limit} 
                                    onChange={e => update('recentActivities', 'limit', e.target.value)} 
                                />
                            </div>
                        </div>
                    </div>
                </div>

                {/* 2. İSTATİSTİKLER KARTI */}
                <div className="bg-surface border border-border p-6 rounded-xl shadow-lg">
                    <h3 className="text-lg font-bold text-white mb-4 flex items-center gap-2"><FaChartBar className="text-purple-400"/> İstatistikler Kartı</h3>
                    <div className="space-y-2">
                        <Switch label="Kartı Göster" checked={settings.statsCard.show} onChange={e => update('statsCard', 'show', e.target.checked)} />
                        
                        <div className={`grid grid-cols-1 gap-2 pl-4 border-l-2 border-gray-700 ${!settings.statsCard.show && 'opacity-50 pointer-events-none'}`}>
                            <h4 className="text-xs font-bold text-gray-500 uppercase mt-2">Görünecek Veriler</h4>
                            <Switch label="Online Kullanıcı Sayısı" checked={settings.statsCard.showOnlineUsers} onChange={e => update('statsCard', 'showOnlineUsers', e.target.checked)} />
                            <Switch label="Toplam Kullanıcı Sayısı" checked={settings.statsCard.showTotalUsers} onChange={e => update('statsCard', 'showTotalUsers', e.target.checked)} />
                            <Switch label="Görüntülenme (Günlük)" checked={settings.statsCard.showDailyViews} onChange={e => update('statsCard', 'showDailyViews', e.target.checked)} />
                            <Switch label="Görüntülenme (Haftalık)" checked={settings.statsCard.showWeeklyViews} onChange={e => update('statsCard', 'showWeeklyViews', e.target.checked)} />
                            <Switch label="Görüntülenme (Aylık)" checked={settings.statsCard.showMonthlyViews} onChange={e => update('statsCard', 'showMonthlyViews', e.target.checked)} />
                            <Switch label="Tüm Zamanlar" checked={settings.statsCard.showAllTimeViews} onChange={e => update('statsCard', 'showAllTimeViews', e.target.checked)} />
                            <Switch label="Kopyalama İstatistikleri" checked={settings.statsCard.showCopyStats} onChange={e => update('statsCard', 'showCopyStats', e.target.checked)} />
                        </div>
                    </div>
                </div>

                {/* 3. DİĞER KARTLAR VE GENEL */}
                <div className="space-y-6">
                    {/* ÜYE SAYISI MANTIĞI */}
                    <div className="bg-surface border border-border p-6 rounded-xl shadow-lg">
                        <h3 className="text-lg font-bold text-white mb-4 flex items-center gap-2"><FaUserCog className="text-yellow-400"/> Üye Sayısı Mantığı</h3>
                        <p className="text-xs text-gray-400 mb-3">"Toplam Üye" kartında kimler sayılsın?</p>
                        <div className="space-y-2">
                            <Switch label="Adminleri Dahil Et" checked={settings.memberCountLogic.includeAdmins} onChange={e => update('memberCountLogic', 'includeAdmins', e.target.checked)} />
                            <Switch label="Muaf (VIP) Üyeleri Dahil Et" checked={settings.memberCountLogic.includeExempt} onChange={e => update('memberCountLogic', 'includeExempt', e.target.checked)} />
                            <Switch label="Pasif Üyeleri Dahil Et" checked={settings.memberCountLogic.includePassive} onChange={e => update('memberCountLogic', 'includePassive', e.target.checked)} />
                        </div>
                    </div>

                    {/* GENEL GÖRÜNÜRLÜK */}
                    <div className="bg-surface border border-border p-6 rounded-xl shadow-lg">
                        <h3 className="text-lg font-bold text-white mb-4 flex items-center gap-2"><FaEye className="text-green-400"/> Genel Görünürlük</h3>
                        <div className="space-y-2">
                            <Switch label="Ödemelerim Kartını Göster" checked={settings.myPaymentsCard.show} onChange={e => update('myPaymentsCard', 'show', e.target.checked)} />
                            <Switch label="Finansal Özet Kartları (Üst)" checked={settings.visibility.showFinancialCards} onChange={e => update('visibility', 'showFinancialCards', e.target.checked)} />
                            <Switch label="Hoş Geldin Mesajı (Sesli/Yazılı)" checked={settings.visibility.showWelcomeMessage} onChange={e => update('visibility', 'showWelcomeMessage', e.target.checked)} />
                        </div>
                        <div className="mt-4">
                            <label className="text-xs text-gray-400 block mb-1">Bakım / Uyarı Mesajı (Boşsa gizlenir)</label>
                            <input 
                                type="text" 
                                placeholder="Örn: Bu gece bakım çalışması var." 
                                className="w-full bg-black/20 border border-gray-600 rounded p-2 text-white text-sm"
                                value={settings.visibility.maintenanceMessage || ''}
                                onChange={e => update('visibility', 'maintenanceMessage', e.target.value)}
                            />
                        </div>
                    </div>
                </div>

            </div>
            )}
        </div>
    );
};

export default ManageDashboardSettingsPage;